import { api } from '@rd-web-markets/shared/dist/services/service';

export const trackingTasksService = {
  all: (claimProjectReportId, queryParams = null) => api.get(`/time_tracking/claim_project_reports/${claimProjectReportId}/tracking_tasks?${queryParams}`),
  get: (claimProjectReportId, id) => api.get(`/time_tracking/claim_project_reports/${claimProjectReportId}/tracking_tasks/${id}`),
  create: (claimProjectReportId, task) => api.create(`/time_tracking/claim_project_reports/${claimProjectReportId}/tracking_tasks`, task),
  update: (claimProjectReportId, id, task) => api.update(`/time_tracking/claim_project_reports/${claimProjectReportId}/tracking_tasks/${id}`, task),
  delete: (claimProjectReportId, id) => api.delete(`/time_tracking/claim_project_reports/${claimProjectReportId}/tracking_tasks/${id}`),
};
